import Vue from 'vue';
import truncate from 'lodash/truncate';

Vue.filter(
  'truncate',
  (str, length) => truncate(str, { length, omission: '…' }),
);



// WEBPACK FOOTER //
// ./filters/truncate.js